import React from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, StarIcon, HeartIcon } from 'lucide-react';
import SearchBar from '../components/SearchBar';
import PropertyCard from '../components/PropertyCard';
import { featuredProperties, popularDestinations } from '../utils/mockData';
const HomePage = () => {
  return <div className="w-full bg-[#F8F5F0]" data-id="element-912">
      {/* Hero Section */}
      <section className="relative h-[500px] md:h-[600px] bg-cover bg-center" style={{
      backgroundImage: "url('https://images.unsplash.com/photo-1571896349842-33c89424de2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1760&q=80')"
    }} data-id="element-913">
        <div className="absolute inset-0 bg-black bg-opacity-40" data-id="element-914"></div>
        <div className="container mx-auto px-4 h-full flex flex-col justify-center relative z-10" data-id="element-915">
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 max-w-2xl" data-id="element-916">
            Discover Authentic B&Bs and Charming Farmstays
          </h1>
          <p className="text-white text-lg md:text-xl mb-8 max-w-xl" data-id="element-917">
            Experience genuine hospitality, homemade breakfasts, and unique farm
            experiences in handpicked accommodations across the country
          </p>
          <SearchBar className="max-w-5xl" data-id="element-918" />
        </div>
      </section>
      {/* Popular Destinations */}
      <section className="container mx-auto px-4 py-12" data-id="element-919">
        <h2 className="text-2xl md:text-3xl font-bold text-[#333333] mb-6" data-id="element-920">
          Popular Destinations
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-921">
          {popularDestinations.map(destination => <Link key={destination.id} to={`/search?destination=${destination.name}`} className="relative rounded-lg overflow-hidden h-48 group" data-id="element-922">
              <img src={destination.image} alt={destination.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" data-id="element-923" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex flex-col justify-end p-4" data-id="element-924">
                <h3 className="text-white font-semibold text-lg" data-id="element-925">
                  {destination.name}
                </h3>
                <p className="text-white text-sm" data-id="element-926">
                  {destination.propertyCount} properties
                </p>
              </div>
            </Link>)}
        </div>
      </section>
      {/* Featured Properties */}
      <section className="container mx-auto px-4 py-12" data-id="element-927">
        <h2 className="text-2xl md:text-3xl font-bold text-[#333333] mb-6" data-id="element-928">
          Featured Properties
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-929">
          {featuredProperties.map(property => <PropertyCard key={property.id} property={property} data-id="element-930" />)}
        </div>
        <div className="mt-10 text-center" data-id="element-931">
          <Link to="/search" className="inline-block bg-[#D4A017] hover:bg-[#c29316] text-white px-6 py-3 rounded-md font-medium transition-colors" data-id="element-932">
            View All Properties
          </Link>
        </div>
      </section>
      {/* Why Choose Us */}
      <section className="bg-white py-16" data-id="element-933">
        <div className="container mx-auto px-4" data-id="element-934">
          <h2 className="text-2xl md:text-3xl font-bold text-[#333333] mb-6 text-center" data-id="element-935">
            Why Choose StayFinder
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-936">
            <div className="text-center p-6" data-id="element-937">
              <div className="bg-[#F8F5F0] rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-938">
                <MapPinIcon className="h-8 w-8 text-[#006D77]" data-id="element-939" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-940">
                Personal Hospitality
              </h3>
              <p className="text-gray-600" data-id="element-941">
                Experience genuine local hospitality and personalized service
                from dedicated hosts and innkeepers.
              </p>
            </div>
            <div className="text-center p-6" data-id="element-942">
              <div className="bg-[#F8F5F0] rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-943">
                <StarIcon className="h-8 w-8 text-[#006D77]" data-id="element-944" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-945">
                Authentic Experiences
              </h3>
              <p className="text-gray-600" data-id="element-946">
                From farm-to-table breakfasts to animal feedings, enjoy unique
                experiences you won't find at hotels.
              </p>
            </div>
            <div className="text-center p-6" data-id="element-947">
              <div className="bg-[#F8F5F0] rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-948">
                <HeartIcon className="h-8 w-8 text-[#006D77]" data-id="element-949" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-950">Local Connections</h3>
              <p className="text-gray-600" data-id="element-951">
                Connect with hosts who offer insider knowledge and authentic
                local recommendations for your stay.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Newsletter */}
      <section className="container mx-auto px-4 py-16" data-id="element-952">
        <div className="bg-[#006D77] rounded-xl p-8 md:p-12 text-center" data-id="element-953">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-954">
            Get Travel Inspiration & Deals
          </h2>
          <p className="text-white mb-6 max-w-2xl mx-auto" data-id="element-955">
            Sign up for our newsletter and receive exclusive offers on new
            properties, travel tips, and more.
          </p>
          <form className="max-w-md mx-auto flex flex-col sm:flex-row gap-3" data-id="element-956">
            <input type="email" placeholder="Your email address" className="flex-1 px-4 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-[#D4A017]" data-id="element-957" />
            <button type="submit" className="bg-[#D4A017] hover:bg-[#c29316] text-white px-6 py-3 rounded-md font-medium transition-colors" data-id="element-958">
              Subscribe
            </button>
          </form>
        </div>
      </section>
    </div>;
};
export default HomePage;